import createCrudModule from '@/utils/createCrudModule'

export default createCrudModule({
  resource: 'materials',
  urlRoot: '/materials'
})
